"use client"

import { WalletCards } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WalletCardsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WalletCardsIcon = component(Icon)({ as: WalletCards })
